import styled from 'styled-components';
export { Bar } from 'styles/shared';

export const Container = styled.main`
  width: 100%;
  margin: 0 auto;
`;

export const Content = styled.section`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 96px 40px;

  @media screen and (max-width: 500px) {
    padding: 56px 40px;
  }
`;

export const Text = styled.article`
  font-size: 18px;
  line-height: 24px;

  p {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
